import { Footer } from '../Footer';
import { RedBanner } from '../RedBanner';
import { RentFastNSave } from '../RentFastNSave';
import { WhyWeRent } from '../WhyWeRent';

import * as style from './Content.css';
import { RentProfit } from '../RentProfit';
import { Faq } from '../Faq';
import { Convenient } from '../Convenient';

interface IContentProps {
  header: JSX.Element;
  solveProblems: JSX.Element;
  protectYou: JSX.Element;
  aboutService: JSX.Element;
  findToday: JSX.Element;
  modal: JSX.Element;
  onChangeVisibleModal: VoidFunction;
}

export const Content: React.FC<IContentProps> = ({
  header,
  solveProblems,
  protectYou,
  aboutService,
  findToday,
  modal,
  onChangeVisibleModal,
}) => {
  return (
    <div className={style['container']}>
      {header}
      <div className={style['wrapper']}>
        <RentFastNSave onChangeModalVisible={onChangeVisibleModal} />
        {solveProblems}
        <RedBanner onChangeModalVisible={onChangeVisibleModal} />
        <WhyWeRent />
        {protectYou}
        <Convenient />
        {aboutService}
        <RentProfit />
        <Faq />
        {findToday}
        {modal}
      </div>
      <Footer />
    </div>
  );
};
